import {AppsState} from '../state/apps.state';
import {
  Actions,
  APPS_CHANGED_ID,
  APPS_DELETED_APP,
  APPS_FETCHED_ALL,
  APPS_FETCHED_MULTIPLE,
  APPS_FETCHED_ONE,
  APPS_SAVED_TILE_GROUPS,
} from '../actions/apps.actions';
import {App} from '../../shared/models/app';
import {EMPTY_ID} from '../../shared/constants/empty-id';

const initialState: AppsState = {
  currentAppId: EMPTY_ID,
  currentAppName: '',
  apps: [],
};

export function AppsReducer(state: AppsState = initialState, action: Actions): AppsState {
  let currentApp: App;
  let newAppsState: App[];

  switch (action.type) {
    case APPS_CHANGED_ID:
      currentApp = state.apps.find((app: App) => {
        if (app.ID === action.appId) {
          return true;
        }
      });

      return {
        ...state,
        currentAppId: action.appId,
        currentAppName: currentApp ? currentApp.Name : '',
      };
    case APPS_FETCHED_ONE:
      newAppsState = [...state.apps];

      // If state.apps already has apps in it, this for loop applies
      let appFoundInState = false;
      for (let i in state.apps) {
        if (newAppsState[i].ID === action.appId) {
          newAppsState[i] = action.appObj;
          appFoundInState = true;
          break;
        }
      }

      if (!appFoundInState) {
        newAppsState.push(action.appObj);
      }

      return {
        ...state,
        apps: newAppsState,
        currentAppName: action.appObj.Name,
      };
    case APPS_FETCHED_MULTIPLE:
      newAppsState = [...state.apps];

      for (let app of action.apps) {
        let appFoundInState = false;

        for (let i in state.apps) {
          if (newAppsState[i].ID === app.ID) {
            newAppsState[i] = app;
            appFoundInState = true;
            break;
          }
        }

        if (!appFoundInState) {
          newAppsState.push(app);
        }
      }

      return {
        ...state,
        apps: newAppsState,
      };
    case APPS_FETCHED_ALL:
      return {
        ...state,
        apps: action.apps,
      };
    case APPS_DELETED_APP:
      return {
        ...state,
        apps: state.apps.filter(
          (app) => {
            return app.ID !== action.appId;
          },
        ),
      };
    case APPS_SAVED_TILE_GROUPS:
      let currentAppIndex = state.apps.findIndex((app: App) => {
        if (app.ID === action.appId) {
          return true;
        }
      });

      let newApp: App = App.create(state.apps[currentAppIndex]);
      newApp.TileGroups = action.tileGroups;

      let newApps: App[] = [...state.apps];
      newApps[currentAppIndex] = newApp;

      return {
        ...state,
        apps: newApps,
      };
    default:
      return state;
  }
}
